module.exports = __webpack_public_path__ + "static/img/8.bb69756.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/8.png
// module id = a4wk
// module chunks = 0